// src/App.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./style.css";

// Toastit
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Pages
import Home from "./Pages/Home/Home";
import Privacy from "./Pages/Privacy/Privacy";
import NotFound from "./Pages/NotFound/NotFound";

// LANDING

// Maakunta

import JoyrideUusimaaLanding from "./Pages/Landing/JoyrideMaakuntaLanding.jsx";
import JoyridePirkanmaaLanding from "./Pages/Landing/JoyridePirkanmaaLanding";
import JoyrideVarsinaisSuomiLanding from "./Pages/Landing/JoyrideVarsinaisSuomiLanding";
import JoyrideKantaHameLanding from "./Pages/Landing/JoyrideKantaHameLanding";
import JoyridePaijatHameLanding from "./Pages/Landing/JoyridePaijatHameLanding";
import JoyrideKymenlaaksoLanding from "./Pages/Landing/JoyrideKymenlaaksoLanding";
import JoyrideEtelaKarjalaLanding from "./Pages/Landing/JoyrideEtelaKarjalaLanding";
import JoyrideEtelaSavoLanding from "./Pages/Landing/JoyrideEtelaSavoLanding";
import JoyrideEtelaPohjanmaaLanding from "./Pages/Landing/JoyrideEtelaPohjanmaaLanding";
import JoyrideSatakuntaLanding from "./Pages/Landing/JoyrideSatakuntaLanding";

// Kaupunki

import JoyrideHelsinkiLanding from "./Pages/Landing/JoyrideHelsinkiLanding";
import JoyrideVantaaLanding from "./Pages/Landing/JoyrideVantaaLanding"
import JoyrideEspooLanding from "./Pages/Landing/JoyrideEspooLanding";
import JoyrideKeravaLanding from "./Pages/Landing/JoyrideKeravaLanding";
import JoyrideJarvenpaaLanding from "./Pages/Landing/JoyrideJarvenpaaLanding";
import JoyrideTampereLanding from "./Pages/Landing/JoyrideTampereLanding";
import JoyrideTurkuLanding from "./Pages/Landing/JoyrideTurkuLanding";
import JoyrideLahtiLanding from "./Pages/Landing/JoyrideLahtiLanding";
import JoyrideHameenlinnaLanding from "./Pages/Landing/JoyrideHameenlinnaLanding";
import JoyridePoriLanding from "./Pages/Landing/JoyridePoriLanding";
import JoyrideLappeenrantaLanding from "./Pages/Landing/JoyrideLappeenrantaLanding";
import JoyrideKouvolaLanding from "./Pages/Landing/JoyrideKouvolaLanding";
import JoyrideMikkeliLanding from "./Pages/Landing/JoyrideMikkeliLanding";
import JoyrideSeinajokiLanding from "./Pages/Landing/JoyrideSeinajokiLanding";

// Components
import Navbar from "./components/Navbar/navbar";
import Footer from "./components/Footer/footer";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import ScrollToHash from "./components/ScrollToHash/ScrollToHash";

function App() {
  return (
    <HelmetProvider>
       <ScrollToHash />
      <div className="App w-full bg-white dark:bg-joyrideNavy z-10">
        <Navbar />

        <div className="container">
          <Routes>
            {/* Ensisijaiset reitit */}
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<Privacy />} />

            {/* Joyride maakuntaländärit */}
            <Route
              path="/bilebandi-uusimaa"
              element={<JoyrideUusimaaLanding />}
            />
            <Route 
              path="/bilebandi-pirkanmaa" 
              element={<JoyridePirkanmaaLanding />} />

            <Route
              path="/bilebandi-varsinais-suomi"
              element={<JoyrideVarsinaisSuomiLanding />}
            />

            <Route 
              path="/bilebandi-kanta-hame"
              element={<JoyrideKantaHameLanding />} />

            <Route 
              path="/bilebandi-paijat-hame"
              element={<JoyridePaijatHameLanding />} />

            <Route 
              path="/bilebandi-kymenlaakso"
              element={<JoyrideKymenlaaksoLanding />} />

            <Route 
              path="/bilebandi-etela-karjala"
              element={<JoyrideEtelaKarjalaLanding />} />

            <Route 
              path="/bilebandi-etela-savo"
             element={<JoyrideEtelaSavoLanding />} />

            <Route
              path="/bilebandi-etela-pohjanmaa"
              element={<JoyrideEtelaPohjanmaaLanding />}
            />

            <Route 
              path="/bilebandi-satakunta"
              element={<JoyrideSatakuntaLanding />} />

            {/* Joyride kaupunkiländärit */}

            <Route
             path="/bilebandi-helsinki" 
             element={<JoyrideHelsinkiLanding />} />

            <Route 
             path="/bilebandi-vantaa" 
             element={<JoyrideVantaaLanding />} />

            <Route 
             path="/bilebandi-espoo" 
             element={<JoyrideEspooLanding />} />

            <Route 
             path="/bilebandi-kerava" 
             element={<JoyrideKeravaLanding />} />

            <Route 
             path="/bilebandi-jarvenpaa" 
             element={<JoyrideJarvenpaaLanding />} />

            <Route 
             path="/bilebandi-tampere" 
             element={<JoyrideTampereLanding />} />

            <Route 
             path="/bilebandi-turku" 
             element={<JoyrideTurkuLanding />} />

            <Route 
             path="/bilebandi-lahti" 
             element={<JoyrideLahtiLanding />} />

            <Route 
             path="/bilebandi-hameenlinna" 
             element={<JoyrideHameenlinnaLanding />} />

            <Route 
             path="/bilebandi-pori" 
             element={<JoyridePoriLanding />} />

            <Route 
             path="/bilebandi-lappeenranta" 
             element={<JoyrideLappeenrantaLanding />} />

            <Route 
             path="/bilebandi-kouvola" 
             element={<JoyrideKouvolaLanding />} />

            <Route 
             path="/bilebandi-mikkeli" 
             element={<JoyrideMikkeliLanding />} />

            <Route 
             path="/bilebandi-seinajoki" 
             element={<JoyrideSeinajokiLanding />} />

            {/* Lopuksi wildcard */}
            <Route path="*" element={<NotFound />} />

          </Routes>
        </div>

        {/* Toastien kontaineri, näkyy kaikilla sivuilla */}
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        {/* Footer näkyy kaikilla sivuilla */}
        <Footer />

        {/* Evästebanneri */}
        <CookieBanner />
      </div>
    </HelmetProvider>
  );
}

export default App;
